import React from "react";
import { ITooltipIndicatorPanel } from "./interface";
import { FadedWithSlideDiv } from "./styles";
import TooltipIndicators from "./tooltip";

const TooltipIndicatorPanel: React.FC<ITooltipIndicatorPanel> = ({
	value,
	onClick
}) => {

	if(!value)
		return null;

	return(
		<FadedWithSlideDiv>
			<TooltipIndicators value={value} onClick={onClick}/>
		</FadedWithSlideDiv>
	);};

export default TooltipIndicatorPanel;
